import { useEffect, useState } from 'react';

/**
 * Creates an object URL for a blob and guarantees revocation when the blob
 * changes or the component unmounts — the single sanctioned way to display
 * blob content, so URLs can't leak.
 */
export function useObjectUrl(blob: Blob | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(blob);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [blob]);

  return url;
}
